import React from 'react';
import DesktopAppDownload from '../components/DesktopAppDownload';
import SEO from '../components/SEO';
import './DesktopDownload.css';

function DesktopDownload() {
  return (
    <div className="desktop-download-page">
      <SEO 
        title="Download BlackKiteAI Desktop App - Windows & macOS"
        description="Download the BlackKiteAI desktop application for Windows and macOS. Get real-time AI interview assistance on your desktop with enhanced performance and privacy."
        canonical="https://www.blackkiteai.com/desktop-download"
      />
      <div className="desktop-download-container">
        <DesktopAppDownload />
      </div>
    </div>
  );
}

export default DesktopDownload;
